module.exports = flarum.core.compat['common/components/LinkButton'];